import React, { useEffect, useState } from 'react';

import classnames from 'classnames';

import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import CloseIcon from '@material-ui/icons/Close';
import LinkIcon from '@material-ui/icons/Link';

import css from '../nibTable.module.sass';

const InputCell = ({
  value: initialValue,
  row: { index, original },
  column: { id },
  rowToEdit,
  updateMyData,
  forceUpdateRow,
  data = {},
}) => {
  const [value, setValue] = useState(initialValue);
  const [isError, setError] = useState(false);
  const oninit = initialValue;
  const onChange = (e) => {
    setValue(e.target.value);
    updateMyData({ accessor: id, value: e.target.value });
  };

  useEffect(() => {
    if (forceUpdateRow.index === index) {
      if (forceUpdateRow.hasOwnProperty(id)) {
        setValue(forceUpdateRow[id]);
        setError(true);
      }
    }
  }, [forceUpdateRow]);

  useEffect(() => {
    if (isError) {
      setTimeout(function () {
        setError(false);
      }, 2000);
    }
  }, [isError]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const onClick = () => {
    if (data.onClick) {
      data.onClick(original);
    }
  };

  if (rowToEdit.index === index && rowToEdit.status && !data.readOnly) {
    return (
      <div className={classnames(css.inputCell, isError && css.error)}>
        <IconButton onClick={() => onChange({ target: { value: oninit } })}>
          <CloseIcon style={{ color: '#fff' }} />
        </IconButton>
        <TextField variant="outlined" size="small" label={false} value={value} onChange={onChange} />
      </div>
    );
  } else {
    return (
      <>
        {data && data.onClick ? (
          <p className={classnames(isError && css.error, css.link)} onClick={onClick} style={{ cursor: 'pointer' }}>
            {value ?? '(not set)'}{' '}
            <span className={css.linkIcon}>
              <LinkIcon />
            </span>
          </p>
        ) : (
          <p className={classnames(isError && css.error)}>{value ?? '(not set)'}</p>
        )}
      </>
    );
  }
};

export default InputCell;
